import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { API_URL, scroll, getValFromLS, setValToLS } from "../../helpers";

import Hdg from "../../components/Hdg";
import Alert from "../../components/Alert";
import Notice from "../../components/Notice";
import Input from "../../components/Input";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

import Nav from "../Nav";

import HotelNav from "./HotelNav";
import HomeTable from "./HomeTable";

const Hotel = () => {
	const [user, setUser] = useState({});
	const [details, setDetails] = useState({});
	const [results, setResults] = useState([]);
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({
		registrationStr: "",
	});
	const [msg, setMsg] = useState({});
	const [notice, setNotice] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const formElement = useRef(null);
	const location = useLocation();

	useEffect(() => {
		if (location.state && location.state.message) {
			setNotice({
				type: location.state.message.type,
				text: location.state.message.text,
			});
		}
	}, [location]);

	useEffect(() => {
		const init = async () => {
			const token = getValFromLS("vtoUserToken")
				? getValFromLS("vtoUserToken")
				: "";
			const url = new URL(`${API_URL}/admin/hotelInit`);
			const params = {
				token,
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setUser({ ...json.user });
					setAlert({});
					scroll();

					if (getValFromLS("hotelRegistrationId", true)) {
						const id = getValFromLS("hotelRegistrationId", true);
						handleSubmit(null, id);
					}
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();

		// eslint-disable-next-line
	}, []);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e = null, id = 0) => {
		if (e) {
			e.preventDefault();
		} else {
			formElement.current.registrationStr.value = id;
			handleUpdate("registrationStr", id);
			setResults([]);
		}
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});
		setDetails({});

		const url = new URL(`${API_URL}/admin/hotel`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (key === "registrationStr" && id) {
				data.append(key, id);
			} else {
				data.append(key, value);
			}
		});
		data.append("token", getValFromLS("vtoUserToken"));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setMsg({
					type: "success",
					text: json.text,
				});

				setDetails({ ...json });
				setValToLS("hotelRegistrationId", json.id, true);
			} else if (json && json.resp === 2) {
				if (json.results.length === 1) {
					handleMatch(json.results[0].id);
				} else {
					setResults(json.results);
					setMsg({
						type: "notice",
						text: json.text,
					});
				}
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleMatch = async (id) => {
		handleSubmit(null, id);
	};

	const handleClick = () => {
		formElement.current.registrationStr.value = "";
		setNames({});
		setDetails({});
		setMsg({});
		setValToLS("hotelRegistrationId", null, true);
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Hotel Management" admin={true} />

						<HotelNav selected="hotel" />

						{notice.type && <Notice data={notice} />}

						<p>
							Use this form to view submitted BFC hotel requests and manage
							statuses.
						</p>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							<div className="form-group">
								<Input
									name="registrationStr"
									label="Registration ID / Organization Name"
									reqd={true}
									value={names.registrationStr || ""}
									update={handleUpdate}
									errors={errors}
									note="Note: Use partial company name if exact match is not found"
								/>

								<div className="empty" />
							</div>

							<div className="msg-submit" style={{ marginTop: "30px" }}>
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" ||
										msg.type === "notice" ||
										msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit submit="Locate Registration" />
								</div>
							</div>

							<div className="results-container">
								{results.map((item) => {
									return (
										<button
											type="button"
											className="naked"
											key={item.id}
											onClick={(e) => handleMatch(item.id)}
										>
											{`${item.id} ${item.name}`}
										</button>
									);
								})}
							</div>
						</form>

						{details.id && (
							<>
								<div className="reset-container">
									<button type="button" className="naked" onClick={handleClick}>
										<i className="fa fa-times-circle-o fa-lg working" />
									</button>
								</div>

								<table
									className="approved assigned"
									style={{ marginBottom: "0" }}
								>
									<thead>
										<tr>
											<th colSpan="5" className="hdg">
												{`${details.organization} - ID ${details.id}`}
											</th>
										</tr>
										<tr>
											<td style={{ width: "20%" }}>Wed, March 31</td>
											<td style={{ width: "20%" }}>Thu, April 1</td>
											<td style={{ width: "20%" }}>Fri, April 2</td>
											<td style={{ width: "20%" }}>Sat, April 3</td>
											<td style={{ width: "20%" }}>Sun, April 4</td>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td className="center">{details.wed}</td>
											<td className="center">{details.thu}</td>
											<td className="center">{details.fri}</td>
											<td className="center">{details.sat}</td>
											<td className="center">{details.sun}</td>
										</tr>
										<tr>
											<td
												className="center"
												colSpan="5"
												style={{
													paddingTop: "12.5px",
													paddingBottom: "12.5px",
												}}
											>
												{details.stripeCustomerId ? (
													<a
														href={`https://dashboard.stripe.com/customers/${details.stripeCustomerId}`}
														target="_blank"
														rel="noopener noreferrer"
													>
														Stripe Credit Card {details.stripeCustomerId}
														&nbsp;&nbsp;
														<i className="fa fa-external-link" />
													</a>
												) : (
													<span className="working">
														-- no credit card on file for this registration --
													</span>
												)}
											</td>
										</tr>
									</tbody>
								</table>
							</>
						)}

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={7} user={user} />
					</div>

					{details.id && <div className="spacer" style={{ height: "0" }}></div>}

					{details.id && (
						<div
							id="full-column"
							style={{ marginTop: "0", paddingTop: "0", minHeight: "100%" }}
						>
							<HomeTable
								text="All Hotel Requests"
								data={details.requests}
								registrationId={details.id}
							/>
						</div>
					)}
				</>
			)}
		</>
	);
};

export default Hotel;
